import type { Theme } from "@mui/material/styles";

export const catalogCardSx = (theme: Theme) => ({
  minWidth: 0,
  height: "100%",
  textDecoration: "none",
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  transition: "border-color 160ms, box-shadow 160ms, transform 160ms",
  "&:hover, &:focus-visible": {
    borderColor: theme.palette.accent,
    boxShadow: `0 8px 24px ${theme.palette.glow}`
  },
  "@media (prefers-reduced-motion: no-preference) and (hover: hover)": {
    "&:hover": { transform: "translateY(-3px)" }
  }
});
